import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { FieldErrors, UseFormRegister } from 'react-hook-form';
import Input from 'v2/form/Input/Input';
import Select from 'v2/form/Select/Select';
import { SignUpFlowFormData } from './SignUpFlow';
import styles from './stepTwo.module.scss';
import QuestionMarkToolTip from 'v2/common/QuestionMarkToolTip/QuestionMarkToolTip';

interface StepTwoProps {
  register: UseFormRegister<SignUpFlowFormData>;
  errors: FieldErrors<SignUpFlowFormData>;
}

const StepTwo = ({ register, errors }: StepTwoProps) => {
  return (
    <div className={styles.root}>
      <FormGroup className="mt-4">
        <Input
          label="Email Address"
          type="text"
          register={register('email', { required: false })}
          maxLength={64}
          autoComplete="off"
          disabled={true}
        />
      </FormGroup>

      <FormGroup>
        <Select
          className="mt-4"
          label="Account Type"
          register={register('user_type', { required: true })}
          error={errors?.user_type?.message}
          required={true}
          options={[
            { label: '', value: '', disabled: true },
            { label: 'Everyone else', value: 'data_buyer' },
            { label: 'Data Provider', value: 'data_seller' },
          ]}
          data-cy="signup:account-type"
        />
      </FormGroup>

      <FormGroup className="mt-4">
        <Input
          label="First Name"
          type="text"
          register={register('first_name', { required: true })}
          error={errors?.first_name?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
          data-cy="signup:first-name"
        />
      </FormGroup>
      <FormGroup className="mt-4">
        <Input
          label="Last Name"
          type="text"
          register={register('last_name', { required: true })}
          error={errors?.last_name?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
          data-cy="signup:last-name"
        />
      </FormGroup>
      <FormGroup className="mt-4">
        <Input
          label="Job Title"
          type="text"
          register={register('job_title', { required: true })}
          error={errors?.job_title?.message}
          maxLength={64}
          autoComplete="off"
          required={true}
          data-cy="signup:job-title"
        />
      </FormGroup>
      <FormGroup className="mt-4">
        <div className="d-flex">
          <label>LinkedIn</label>
          <QuestionMarkToolTip
            styles={styles}
            helpText="You are more likely to be approved quickly if you fill in your LinkedIn address"
          />
          {errors?.linkedin_url && (
            <div className={styles.linkedinError}>
              {errors.linkedin_url.message}
            </div>
          )}
        </div>
        <Input
          type="text"
          register={register('linkedin_url')}
          error={errors?.linkedin_url?.message}
          maxLength={100}
          autoComplete="off"
          data-cy="signup:linkedin-url"
        />
      </FormGroup>
    </div>
  );
};

export default StepTwo;
